// Hierarchical element type structure and related utilities
export const elementTypeHierarchy = {
  'Complete system': [
    'Complete drainage system',
    'Sump pump waste drainage systems', 
    'Sewerage waste drainage systems',
    'Separator drainage systems',
    'Gutters and drainage channels',
    'Waste water drainage systems generally',
    'Test of UG mains drainage pipework',
    'Others'
  ],
  'Water systems': [
    'Water supply system',
    'Hot water system', 
    'Cold water system',
    'Water treatment system',
    'Water storage systems',
    'Others'
  ],
  'Gas systems': [
    'Natural gas system',
    'LPG gas system',
    'Gas safety systems',
    'Gas meters and controls',
    'Others'
  ],
  'Rainwater drainage systems': [
    'Roof drainage',
    'Gutters and downpipes',
    'Rainwater collection',
    'Stormwater drainage',
    'Others'
  ],
  'Technical Building Equipment': [
    'HVAC Systems',
    'Electrical Installations',
    'Building Management Systems',
    'Lift and Escalator Installations',
    'Fire Protection Systems',
    'Security Systems',
    'Others'
  ],
  'Building Construction': [
    'Structural Elements',
    'Facades and Walls',
    'Roofs and Coverings',
    'Windows and Doors',
    'Interior Elements',
    'Others'
  ]
};

// Get all element options for hierarchical dropdown
export const getAllElementOptions = () => {
  const options = [];
  Object.keys(elementTypeHierarchy).forEach(category => {
    // Add category header
    options.push({
      label: category,
      value: category,
      isHeader: true,
      disabled: true
    });
    // Add subcategory options
    elementTypeHierarchy[category].forEach(item => {
      options.push({
        label: `  ${item}`, // Indent subcategories
        value: `${category} - ${item}`,
        isHeader: false,
        category: category,
        item: item
      });
    });
  });
  return options;
};
